"use strict";
/// <reference path="irep.js"/>

IREP.rxt = (function () {
    var url;
    var _options;

    var init = function (options) {
        var queryString = {};

        if (document.documentMode <= 10) {
            configureIEMode();
        }
        _options = options;

        if (document.location.search !== "") {
            $.each(document.location.search.substr(1).split('&'), function (c, q) {
                var i = q.split('=');
                queryString[i[0].toString()] = i[1].toString();
            });
            var code = queryString.Code;
            if (typeof code != 'undefined') {
                if (code != "") {
                    $("#divFUOverlayHolder").show();
                    $("#dropbox").hide();
                    $("#divInput").hide();
                    $("#divConfirmationScreen").css("height", "410px").show();
                    $("#divResults").html(_options.ThankYou);
                    $("#uploadButton").hide();
                    $("#divFileWrapper").hide();
                    $("#divNext").hide();
                }
                if (code !== "Success") {
                    $("#divConfirmationScreen").css("color", "white").css("font-size", "24px");
                    $("#divResults").html(getErrorMessage(code, queryString.FileName));
                    $(".divUploadAgain").show();
                }
            }
        }
        else {
            $("#divFUOverlayHolder").hide();
        }

        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            $el,
            currentDiv = 0,
            topPosition = 0;
        
        $('.heightMatch').each(function () {

            $el = $(this);
            topPosition = $el.position().top;

            if (currentRowStart != topPosition) {

                // we just came to a new row.  Set all the heights on the completed row
                for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }

                // set the variables for the new row
                rowDivs.length = 0; // empty the array
                currentRowStart = topPosition;
                currentTallest = $el.height();
                rowDivs.push($el);

            } else {

                // another div on the current row.  Add it to the list and check if it's taller
                rowDivs.push($el);
                currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);

            }

            // do the last row
            for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }

        });
        
    };
    var dropbox = $('#dropbox'),
    message = $('.message', dropbox);
    var configureIEMode = function () {
        $("#btnUploadFile").hide();
        $("#divFileWrapper").show();
        $("#divFileWrapper").css("width", "500px");
        $("#divFileWrapper").css("height", "200px");
        $("#dropbox").hide();
        $("#file").hide();
    }
    var initDropBox = function () {
        dropbox.filedrop({
            paramname: 'metrics',
            maxfiles: 1,
            maxfilesize: 2, //in MB
            url: _options.url,
            data: {
                PaxUID: IREP.options.user.currentUID,
                FileUploadTypeId: 248,
                CustomerInteractions: $.trim($("#txtCustomerInteractions").val()),
                SalesInteractions: $.trim($("#txtSalesInteractions").val())
            },
            uploadFinished: function (i, file, response) {
                //Upon upload completion, we want to hide the drop area and show the cropper control. 
                $('.progressHolder').css("display", "none");
                $("#divInput").hide();
                if (response.code === "Success") {
                    $("#dropbox").hide();
                    $("#divConfirmationScreen").show();
                    $("#divResults").html(_options.ThankYou);
                    $("#uploadButton").hide();
                    $("#txtCustomerInteractions").val("");
                    $("#txtSalesInteractions").val("");
                    $("#divCloseButton").show();
                }
                else {
                    showMessage(getErrorMessage(response.code, response.fileName));
                    $("#divInput").hide();
                    $("#divUploadAgain").show();
                }
            },

            error: function (err, file) {
                switch (err) {
                    case 'BrowserNotSupported':
                        showMessage(_options.ErrorBrowserNotSupported);
                        break;
                    case 'TooManyFiles':
                        alert(_options.ErrorTooManyFiles);
                        break;
                    case 'FileTooLarge':
                        alert(file.name + _options.ErrorFileTooLarge);
                        break;
                    default:
                        break;
                }
            },

            //Function renders a progress indicator for uploads.
            uploadStarted: function (i, file, len) {
                if (checkFileName(file.name)) {
                    $('.progressHolder').css("display", "block");
                    $("#uploadButton").hide();
                    showMessage(_options.Uploading);
                }
                else {
                    alert(_options.ErrorInvalidFileType);
                    return false;
                }
            },

            //Updates the progress bar. 
            progressUpdated: function (i, file, progress) {
                $('.progress').width(progress * 2.85);
            }

        });
    }

    var checkFileName = function (fileName) {
        var ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
        if (ext != "csv") {
            return false;
        }
        return true;
    };

    var showMessage = function (msg) {
        message.html(msg);
    };

    var enableNextStep = function () {
        $("#uploadButton").show();
        $("#txtCustomerInteractions").attr("disabled", true);
        $("#txtSalesInteractions").attr("disabled", true);
        $("#nextButton").hide();
        $("#dropbox").show();
        $("#divUpload").show();
        $("#qtyErrorMsg").hide();
        $(".divUploadAgain").hide();
        $("#btnUploadFile").hide();
        if (document.documentMode <= 10) {
            $("#dropbox").hide();
            $("#btnUploadFile").show();
        }
    };

    var getErrorMessage = function (code, fileName) {
        var message;
        switch (code) {
            case "FileTooLarge":
                message = _options.ErrorFileTooLarge;
                break;
            case "FileEmpty":
                message = _options.ErrorFileEmpty;
                break;
            case "FileTypeExtensionInvalid":
                message = _options.ErrorFileTypeExtensionInvalid;
                break;
            case "FileTypeContentsDoNotMatch":
                message = _options.ErrorFileTypeContentsDoNotMatch;
                break;
            case "FileFormatInvalid":
                message = _options.ErrorFileFormatInvalid;
                break;
            case "FileDataInvalid":
                message = _options.ErrorFileDataInvalid;
                break;
        }
        if (typeof message != 'undefined') {
            message = message.replace("{0}", fileName);
        }
        return message;
    };
    var enableFirstStep = function () {
        $("#txtCustomerInteractions").attr("disabled", false);
        $("#txtSalesInteractions").attr("disabled", false);
        $("#divFUOverlayHolder").css("display", "block");
        $("#divConfirmationScreen").hide();
        $("#divFileWrapper").hide();
        $("#dropbox").hide();
        $("#divUpload").hide();
        $(".divUploadAgain").hide();
        $("#divCloseButton").hide();
        $("#nextButton").show();
        $("#divInput").show();
        $("#divNext").show();
        showMessage(_options.Instructions);
        $("#divInput").css("margin-top", "80px").css("margin-left", "150px");
        $('.progress').width(0);
        if (document.documentMode <= 10) {
            configureIEMode();
        }
    };

    $("input:file").change(function () {
        var fileName = $(this).val();
        if (fileName !== "")
        {
            $('#btnUploadFile').click();
        }
    });

    $(".divUploadAgain").click(function () {
        enableFirstStep();
        $(".divUploadAgain").hide();
    });
    $("#divUploadFile").click(function () {
        enableFirstStep();
    });
    $(document).keyup(function (e) {
        if (e.which === 27) { //Pressing escape should close overlays. 
            $("#divFUOverlayHolder").hide();
        }
    });
    $("#divCloseUploadButton").on("click", function () {
        $("#divFUOverlayHolder").hide();
    });
    $("#btnClose").on("click", function () {
        $("#divFUOverlayHolder").hide();
    });

    $("#nextButton").on("click", function () {
        var cust = $.trim($("#txtCustomerInteractions").val());
        var sales = $.trim($("#txtSalesInteractions").val());
        $("#txtCustomerInteractions ~ span:first").hide();
        $("#txtSalesInteractions ~ span:first").hide();
        if (cust === "" || cust % 1 !== 0) {
            $("#txtCustomerInteractions ~ span:first").show();
        }
        if (sales === "" || sales % 1 !== 0) {
            $("#txtSalesInteractions ~ span:first").show();
        }

        if (cust > 1000) {
            $("#qtyErrorMsg").show();
        }
        if (sales > 1000) {
            $("#qtyErrorMsg").show();
        }
        if (cust !== "" && sales != "" && sales % 1 === 0 && cust % 1 === 0 && cust <= 1000 && sales <= 1000) {
            enableNextStep();
            initDropBox();
        }

    });
    $("#downloadRXT_android").on("click", function () {
        IREP.track("RXT", "download", 'RXT-Android', '', '');
    })
    $("#downloadRXT_windows").on("click", function () {
        IREP.track("RXT", "download", 'RXT-Windows', '', '');
    })
    $("#uploadButton").on("click", function () {

        $(':file').click().hide(); //This is to click the file input element
        //$(this).hide();
        $("#divFileWrapper").show().css("width", "500px").css("height", "200px").css("margin-left", "100px");
        $("#dropbox").hide();
        $("#divInput").css("margin-top", "150px");
    });

    $('#btnUploadFile').on("click", function () {
        $("#txtCustomerInteractions ~ span:first").hide();
        $("#txtSalesInteractions ~ span:first").hide();
        var fileName = $("#file").val();
        var customer = $.trim($("#txtCustomerInteractions").val());
        var sales = $.trim($("#txtSalesInteractions").val());

        if (fileName === "") { 
            alert("Please select a file to upload");
            if (document.documentMode <= 10) {
                $(':file').click();
            }
            else {
                $(':file').click().hide();
            }
            
            return false;
        }
        else if (customer === "") {
            $("#txtCustomerInteractions ~ span:first").show();
            return false;
        }
        else if (sales === "") {
            $("#txtSalesInteractions ~ span:first").show();
            return false;
        }
        else {//form post
            $("#CustomerInteractions").val(customer);
            $("#SalesInteractions").val(sales);
            $("#divInput").hide();
            $(this).hide();
            $("#message").html(_options.Uploading);
        }

    });
    
    return {
        init: init
    };
}());